import { Link } from "react-router";

export const LogoURL = '/cropped-cropped-djituhs-1.webp';

export default function Logo({ src = '', className = "navbar-brand-image", ...rest }: { className?: string, [x: string]: any }) {
    return (
        <Link to="/">
            <img src={src} alt="Logo" className={className} {...rest} />
        </Link>
    );
}